export default __webpack_public_path__ + "static/media/adelia.21c16d44.jpeg";